import React, { Component } from 'react';
import BioPhoto from './BioPhoto';
import MemberQRCard from './MemberQRCard';
import torritb from '../assets/torritb.png';
import bmz from '../assets/bmz.png';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Bio.css';

class BioTorritb extends Component {
  state = {
    user: null,
    loading: true,
    error: '',
  };

  async componentDidMount() {
    try {
      const email = localStorage.getItem('email');

      if (!email) {
        throw new Error('No email found. Please login again.');
      }

      const res = await fetch(`/user-details?email=${encodeURIComponent(email)}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Failed to fetch user data');
      }

      this.setState({
        user: {
          email: data.email,
          balance: data.balance,
          name: 'MR. TORRIT BOONYAKIAT',
          dojo: 'BANGKOK MARTIAL ARTS AND ZEN CENTER, BANGKOK, THAILAND',
          rank: '4 DAN',
          rankDate: '20/12/24',
          membershipNumber: '2058',
          membershipExpiry: '05/08/26',
          nationality: 'THAILAND',
        },
        loading: false,
      });
    } catch (err) {
      console.error('Error fetching user data:', err);
      this.setState({
        error: err.message,
        loading: false,
      });
    }
  }

  renderUserInfo() {
    const { user } = this.state;

    return (
      <div style={{ marginBottom: '20px' }}>
        <div><strong>Email:</strong> {user.email}</div>
        <div><strong>Balance:</strong> {user.balance}</div>
      </div>
    );
  }

  render() {
    const { user, loading, error } = this.state;

    return (
      <div className="BioTorritb">
      <img
      className="top-logo"
      src={logo}
      alt="App Logo"
      />
        <h1>Member's Biography</h1>

        {loading && <div>Loading user data...</div>}

        {error && (
          <div style={{ color: 'red', marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {user && this.renderUserInfo()}

        <BioPhoto
          slug="torritb"
          fallback={torritb}
          className="chaiwatt"
          alt="Torrit Boonyakiat"
        />

        <h2>{user ? user.name : 'MR. TORRIT BOONYAKIAT'}</h2>

        <img className="renbukan" src={bmz} alt="Bangkok Martial Arts and Zen Center" />

        <br />
        <br />

        <div>
          DOJO : {user ? user.dojo : 'BANGKOK MARTIAL ARTS AND ZEN CENTER, BANGKOK, THAILAND'}
        </div>

        <div>
          CURRENT RANK : {user ? `${user.rank} (${user.rankDate})` : '4 DAN (20/12/24)'}
        </div>

        <div>
          AAT MEMBERSHIP NUMBER : {user ? `${user.membershipNumber} (Expired : ${user.membershipExpiry})` : '2058 (Expired : 05/08/26)'}
        </div>

        <div>
          DATE OF BIRTH : N/A
        </div>

        <div>
          NATIONALITY : {user ? user.nationality : 'THAILAND'}
        </div>

        <br />

        <MemberQRCard slug="torritb" />

        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default BioTorritb;
